import React from 'react';
// icons
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
// logic
import { useHistory } from 'react-router-dom';
// components
import ToolBarButton from '../ui/toolbar/toolBarButton';
import ToolbarTitle from '../ui/toolbar/toolbarTitle';
import RegularText from '../ui/texts/RegularText';
import ToolbarContainer from '../ui/containers/toolbarContainer';

const NewQuoteToolbar = ({ id, customerName, className, ticketDetail }) => {
  const history = useHistory();

  return (
    <ToolbarContainer>
      <div>
        <RegularText>Quote for {customerName}</RegularText>
        <ToolbarTitle>
          REF. {ticketDetail?.order_data?.complementary_info?.customer_internal_reference}
        </ToolbarTitle>
      </div>
      <ToolBarButton
        onClick={() => {
          history.push('/emergencies/');
        }}
      >
        <CloseIcon />
      </ToolBarButton>
    </ToolbarContainer>
  );
};

export default NewQuoteToolbar;
